

import { type State } from '../../types';
import { type BrandingImageState } from './brandingImageReducer';

function selectRoot(state: State): BrandingImageState {
  return state.entities.brandingImage;
}

export function isImageUrlsLoading(state: State): boolean {
  return selectRoot(state).isLoading;
}

export function selectImageUrl(state: State): string {
  return selectRoot(state).imageUrl || '';
}

export function hasErrorGettingImages(state: State): boolean {
  return selectRoot(state).hasError;
}
